import React from 'react';
import PropTypes from 'prop-types';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { RevealPanelWithTable } from '../RevealPanel';
import { contentPropTypes } from '../../managePayee/components/managePayeeList/managePayeeList.content';
import { getErrorData, type, getFormattedData, getFormattedDataBackend } from '../../utils/benImportUtils';

export const CLIENT_SIDE = 'Client';
export const SERVER_SIDE = 'Server';
export const PARTIAL_SUCCESS_WITH_ERROR = 'partialSuccessWithError';
export const PARTIAL_SUCCESS_WITH_DUP = 'partialSuccessWithDuplicates';
export const PARTIAL_SUCCESS_WITH_ERROR_AND_DUP = 'partialSuccessWithErrorAndDuplicates';
export const ERROR_AND_DUP_ONLY = 'errorsAndDuplicatesOnly';
export const ERROR_ONLY = 'errorOnly';

export const FileUploadRenderContent = ({
	content,
	formattedData,
	errorType,
	successCount,
	contentType,
	maxRecordsLimit,
	parserErrorMsg,
}) => {
	const {
		subHeader,
		footer,
		panelHeader,
		panelSubHeader,
		tableHeader,
		partialSuccessHeaderWithError,
		partialSuccessHeaderWithDuplicates,
		partialSuccessHeaderWithErrorAndDuplicates,
		noImports,
		duplicateAndErrorHeader,
		errorHeader,
	} = content;
	function getHeaderText(type) {
		switch (type) {
			case PARTIAL_SUCCESS_WITH_ERROR:
				return partialSuccessHeaderWithError;
			case PARTIAL_SUCCESS_WITH_DUP:
				return partialSuccessHeaderWithDuplicates;
			case PARTIAL_SUCCESS_WITH_ERROR_AND_DUP:
				return partialSuccessHeaderWithErrorAndDuplicates;
			case ERROR_AND_DUP_ONLY:
				return duplicateAndErrorHeader;
			case ERROR_ONLY:
				return errorHeader;
			default:
				return noImports;
		}
	}
	switch (contentType) {
		case CLIENT_SIDE: {
			const typeOfFrontendError = type(errorType);
			const formattedErrorData = getFormattedData(formattedData);
			const showRevealPanel = typeOfFrontendError === 'parseError';
			return (
				<div>
					{subHeader && (
						<StandardBody>
							<p>{subHeader.replace('[[limit]]', maxRecordsLimit)}</p>
						</StandardBody>
					)}
					{showRevealPanel && (
						<RevealPanelWithTable
							panelHeader={panelHeader}
							panelSubHeader={panelSubHeader}
							columns={tableHeader}
							data={formattedErrorData}
							parserErrorMsg={parserErrorMsg}
						/>
					)}
					{footer}
				</div>
			);
		}
		case SERVER_SIDE: {
			const formattedErrorData = !type(errorType)
				? getFormattedDataBackend(getErrorData(formattedData))
				: formattedData;

			const showPanels = [
				PARTIAL_SUCCESS_WITH_ERROR,
				PARTIAL_SUCCESS_WITH_ERROR_AND_DUP,
				ERROR_AND_DUP_ONLY,
				ERROR_ONLY,
				'userDataError',
			];
			const showRevealPanel = showPanels.indexOf(errorType) >= 0;
			return (
				<span>
					<span>
						{successCount} {getHeaderText(errorType)}
					</span>
					{showRevealPanel && (
						<RevealPanelWithTable
							panelHeader={panelHeader}
							panelSubHeader={panelSubHeader}
							columns={tableHeader}
							data={formattedErrorData}
						/>
					)}
				</span>
			);
		}
		default:
			return null;
	}
};
FileUploadRenderContent.defaultProps = {
	successCount: 0,
};

FileUploadRenderContent.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	formattedData: PropTypes.arrayOf(PropTypes.object).isRequired,
	errorType: PropTypes.string.isRequired,
	successCount: PropTypes.number,
	contentType: PropTypes.string,
	maxRecordsLimit: PropTypes.number,
	parserErrorMsg: PropTypes.string.isRequired,
};
